import React from 'react';
import PropTypes from 'prop-types';

class NavSideBarListItem extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    this.props.loadStaticBuilderSection(this.props.screenIdx);
    window._track(`${this.props.documentType} | Builder`, `${this.props.section} | Menu`);
  }

  render() {
    return (
      <li className={this.props.className} >
        {!this.props.offsiteBuilder &&
          <span className="builder-navbar-number">
            {this.props.title}
          </span>
        }
        <a
          className="navbar-item-link"
          href=""
          onClick={this.onClick}
          style={{
            overflow: 'hidden',
          }}
        >
          {this.props.section}
        </a>
        {!this.props.offsiteBuilder &&
          <img
            alt="check"
            className="builder-navbar-img"
            src={`${window.cdnUrl}/images/icons/icon-nav-confirm.png`}
          />
        }
      </li>
    );
  }
}

NavSideBarListItem.defaultProps = {
  className: '',
  offsiteBuilder: false,
};

NavSideBarListItem.propTypes = {
  className: PropTypes.string,
  documentType: PropTypes.string.isRequired,
  loadStaticBuilderSection: PropTypes.func.isRequired,
  offsiteBuilder: PropTypes.bool,
  screenIdx: PropTypes.number.isRequired,
  section: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default NavSideBarListItem;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/NavSideBarList/NavSideBarListItem.jsx